export default {
    'OPERACION_DOC': (state, mutation) => {
        state.documento = mutation.documento
    }
}